import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

export const callDetails = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.VIDEO.CALL_DETAILS,
      method: 'get',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
